export const CheckmarkIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0Z"
      fill="var(--color-web-purple2)"
    />
    <path d="M15.127 7.46875L9.10986 13.4858L4.97311 9.34909" stroke="#382365" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const CalendarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 2H16V1C16 0.45 15.55 0 15 0C14.45 0 14 0.45 14 1V2H6V1C6 0.45 5.55 0 5 0C4.45 0 4 0.45 4 1V2H3C1.9 2 1 2.9 1 4V18C1 19.1 1.9 20 3 20H17C18.1 20 19 19.1 19 18V4C19 2.9 18.1 2 17 2ZM17 18H3V8H17V18Z"
      fill="currentColor"
    />
  </svg>
);

export const CancelIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM15 13.59L13.59 15L10 11.41L6.41 15L5 13.59L8.59 10L5 6.41L6.41 5L10 8.59L13.59 5L15 6.41L11.41 10L15 13.59Z"
      fill="currentColor"
    />
  </svg>
);

export const UploadIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04ZM14 13V17H10V13H7L12 8L17 13H14Z"
      fill="currentColor"
    />
  </svg>
);

export const ExclamationIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0Z"
      fill="white"
    />
    <path
      d="M10 5C10.5523 5 11 5.44772 11 6V10C11 10.5523 10.5523 11 10 11C9.44772 11 9 10.5523 9 10V6C9 5.44772 9.44772 5 10 5Z"
      fill="#f04e52"
    />
    <path
      d="M10 13C10.5523 13 11 13.4477 11 14C11 14.5523 10.5523 15 10 15C9.44772 15 9 14.5523 9 14C9 13.4477 9.44772 13 10 13Z"
      fill="#f04e52"
    />
  </svg>
);

export const MessageIcon = () => (
  <svg width="20" height="20" viewBox="0 -2 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 1H2C1.45 1 1 1.45 1 2V17L4 14H18C18.55 14 19 13.55 19 13V2C19 1.45 18.55 1 18 1Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="6" cy="7" r="1.25" fill="currentColor" />
    <circle cx="10" cy="7" r="1.25" fill="currentColor" />
    <circle cx="14" cy="7" r="1.25" fill="currentColor" />
  </svg>
);

export const InsuranceIcon = () => (
  <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 4.142c0-1.069-.67-2.028-1.671-2.387C14.029 1.286 11.412.5 8.5.5s-5.531.788-6.831 1.258A2.544 2.544 0 000 4.144v7.938c0 1.639.912 2.697 1.4 3.264l.08.092c.569.674 1.227 1.286 2.736 2.253.595.38 1.384.83 2.345 1.337 1.193.63 2.68.63 3.875 0 .96-.508 1.75-.957 2.345-1.337 1.5-.957 2.157-1.569 2.73-2.247l.095-.111c.488-.571 1.392-1.63 1.392-3.258V4.137l.002.005zm-1.26 7.936c0 1.16-.629 1.898-1.089 2.434l-.095.111c-.421.5-.928 1.03-2.45 2-.566.36-1.321.795-2.25 1.283-.418.219-.884.335-1.354.335-.468 0-.938-.117-1.354-.335a31.678 31.678 0 01-2.254-1.284c-1.527-.979-2.03-1.505-2.45-1.999l-.088-.104c-.462-.536-1.092-1.27-1.092-2.433V4.148c0-.526.343-1.018.834-1.195C3.323 2.51 5.78 1.771 8.505 1.771c2.723 0 5.182.738 6.403 1.182.491.177.838.669.838 1.195v7.938l-.005-.008z"
      fill="currentColor"
    />
    <path
      d="M11.648 8.736H9.13V6.201a.633.633 0 00-.63-.634.633.633 0 00-.63.634v2.535H5.352a.633.633 0 000 1.268H7.87v2.535c0 .349.283.633.63.633.347 0 .63-.284.63-.633v-2.535h2.518a.633.633 0 000-1.268z"
      fill="currentColor"
    />
  </svg>
);

export const RescheduleIcon = () => (
  <svg width="11" height="11" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.426 11.5a5.377 5.377 0 002.958-.885 5.267 5.267 0 001.96-2.356c.404-.96.51-2.015.304-3.033a5.228 5.228 0 00-1.457-2.688A5.347 5.347 0 007.465 1.1a5.393 5.393 0 00-3.076.299A5.308 5.308 0 002 3.333"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
    />
    <path d="M1.564 1.75l-.007 2.121 2.121.007" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
  </svg>
);
